module.exports = __webpack_public_path__ + "static/media/justify_black.5801f986.svg";